module.exports = __webpack_public_path__ + "img/iphone.9e581766.png";